module.exports = __webpack_public_path__ + "img/dnd-officialart-unknown.ba80272a.jpg";